import { AppConfig } from "./app-config";
import { externalPaths } from "./static_envs";
import { ENVS } from "./envs";

export const config: AppConfig = {
	apiUrl: "https://api.staging.waskurzes.com",
	apiUrlGql: "https://api.staging.waskurzes.com/v1/graphql",
	apiUrlGqlStaking: "https://api.staging.waskurzes.com/staking/v1/graphql",
	apiUrlGqlBff: "https://api.staging.waskurzes.com/graphql-gateway/graphql",
	wsUrlGql: "ws://api.staging.waskurzes.com/v1/graphql",
	apiVersion: "v1",
	debug: true,
	envName: ENVS.STAGING,
	authEnvName: ENVS.STAGINGUK,
	siftScienceAPIKey: "6874733b74",
	storylyToken:
		"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2NfaWQiOjEwODcyLCJhcHBfaWQiOjE2Mzc0LCJpbnNfaWQiOjE4NzA4fQ.IrPHWGuiv9WNRT5w05lPAHrSsNpBe2h8uNi3Wkkk7Iw",
	executeSift: false,
	socketUrl: "https://socket.staging.waskurzes.com",
	baseUrl: "https://www.bitpanda.com/",
	refUrl: "https://www.bitpanda.com/",
	cmsUrl: "https://bitpanda.cms.staging.waskurzes.com/",
	appUrl: "https://web.staging.waskurzes.com/",
	iOSUrl: "bitpanda://web.staging.waskurzes.com",
	helpcenterUrl: "https://support.bitpanda.com/",
	modalCoins: ["zec"],
	dryRun: false,
	customProviders: {
		openpayment: {
			callbackUrl: "https://api.waskurzes.com/v1/openpayment/handle",
			scriptUrl: "https://test.oppwa.com/v1/paymentWidgets.js?checkoutId=%s"
		},
		zimpler: {
			callbackUrl: "https://api.waskurzes.com/v1/zimpler/handle",
			scriptUrl: "https://api-sandbox.zimpler.net/assets/v3/zimpler.js"
		},
		paytr: {
			scriptUrl: "https://www.paytr.com/js/iframeResizer.min.js",
			iframeUrl: "https://www.paytr.com/odeme/api/"
		},
		paysafe: {
			scriptUrl: "https://hosted.paysafe.com/js/v1/latest/paysafe.min.js"
		}
	},
	videoId: {
		jsFilePath: "https://etrust-sandbox.electronicid.eu/v2/js/videoid.js"
	},
	externalPaths: externalPaths,
	exchange: {
		appUrl: "https://exchange.waskurzes.com"
	},
	segment: {
		writeKey: "LRMv7xwlCwi0EbRJmqRiQCO2KtGl78Xt"
	},
	rudderstack: {
		writeKey: "3362XXfFUj7C9XLhLqnQZekfIvq",
		dataPlaneUrl: "https://bitpandasqdvof.dataplane.rudderstack.com"
	},
	braze: {
		server: "sdk.fra-01.braze.eu",
		apiKey: "ad2643f1-0209-4a8a-98fa-db2dfe38ac1c"
	},
	google: {
		mapsPlacesApi:
			"https://maps.googleapis.com/maps/api/js?key=AIzaSyBMPojnMrTWMWWB1mRzIGT7SZ5kKIzW4pY&libraries=places&v=weekly&language=en&callback=Function.prototype"
	},
	firebaseApiKey: "AIzaSyBIjzGeM_O6JwNXRewz_j965QouA88cx4A",
	staticAssetLink: "https://bitpanda-broker-staging-assets.s3.eu-west-1.amazonaws.com/static/",
	staticAssetV4Link: "https://cdn.cms.staging.waskurzes.com/logos/v4/asset/light/",
	advancedTrading: {
		interfaceUrl: "https://fusion.staging.waskurzes.com/",
		termsUrl: {
			en: "https://www.bitpanda.com/en/legal/bitpanda-advanced-terms-conditions",
			de: "https://www.bitpanda.com/de/legal/bitpanda-advanced-terms-conditions",
			fr: "https://www.bitpanda.com/fr/legal/bitpanda-advanced-terms-conditions",
			it: "https://www.bitpanda.com/it/legal/bitpanda-advanced-terms-conditions",
			es: "https://www.bitpanda.com/es/legal/bitpanda-advanced-terms-conditions",
			pl: "https://www.bitpanda.com/pl/legal/bitpanda-advanced-terms-conditions"
		}
	},
	redirectWebApp: "https://web.staging.waskurzes.com/",
	ssnCountry: {
		it: {
			documentationLink: "https://codicefiscale.it/",
			validation: {
				minLength: 16,
				maxLength: 16
			}
		},
		ee: {
			validation: {
				minLength: 11,
				maxLength: 11
			}
		},
		es: {
			validation: {
				minLength: 9,
				maxLength: 10
			}
		},
		is: {
			validation: {
				minLength: 10,
				maxLength: 11
			}
		},
		mt: {
			validation: {
				minLength: 8,
				maxLength: 9
			}
		},
		pl: {
			validation: {
				minLength: 11,
				maxLength: 11
			}
		}
	},
	scriptsConfig: {
		hotjarSiteId: "5099403"
	},
	statsigApiKey: "client-EaJtHn0Yy9vtiMY32UvIt9tJWukVwXnbPTTuCbkDoGn",
	V4AppBaseUrl: "https://app.staging.waskurzes.com",
	statsigProxyUrl: "https://ff.staging.waskurzes.com/v1"
};
